import styled from "styled-components";

export const Wrapper = styled.div`
  font-family: 'MaisonNeueBook', sans-serif;
  color: ${props => props.theme.lightTheme.colors.text};
  font-size: 12px;
  text-align: left;
  padding: 1em 0;
  margin-bottom: 0; //reset default
`